//Cards - Debts
export const NENHUM_DEBITO_SELECIONADO = "Selecione ao menos um débito.";
export const NENHUM_DEBITO_ENCONTRADO_SISTEMA = "Não foram encontrados débitos no sistema.";
export const NENHUM_DEBITO_OCULTO_ENCONTRADO_SISTEMA = "Não foram encontrados débitos ocultos no sistema.";

//FormsValidation
export const CAMPO_CONTRIBUINTE_OBRIGATORIO = "O campo CONTRIBUINTE é obrigatório.";
export const CAMPO_CONTRIBUINTE_INVALIDO = "O campo CONTRIBUINTE é inválido.";
export const CAMPO_PERIODO_INVALIDO = "A data inserida é inválida.";

//Formas de pagamento de crédito
export const DEBITOS_JA_FORAM_QUITADOS = "Operação não permitida. Um ou mais débitos listados já foram quitados.";
export const DATA_PAGAMENTO_HOJE_ULTIMO_DIA_MES = "A data de pagamento deve estar entre hoje e o último dia útil do mês.";
export const SELECIONAR_UM_ITEM = "Você precisa de no mínimo 1 item para realizar o pagamento com cartão de crédito.";

export const PAGAMENTO_TRIBUTO_FEITO_APOS_DATA_VENCIMENTO = "Em caso de pagamento de tributo feito após a data de vencimento original, o DAM a ser emitido terá seu valor atualizado considerando os encargos cabíveis (atualização monetária, juros de mora e multa de mora), que se somarão ao valor original do débito.Operação não permitida. Um ou mais débitos listados já foram quitados.";
export const SELECIONE_CREDENCIADO = "Selecione uma credenciada para prosseguir.";

export const NENHUM_FILTRO_PREENCHIDO = "Preencha ao menos um campo do filtro.";

export const DEBITO_OCULTADO_SELECIONADO = "Débitos ocultados selecionados, para Emitir DAM com esses débitos utilize a funcionalidade de exibir"

export default {
    NENHUM_DEBITO_SELECIONADO,
    NENHUM_DEBITO_ENCONTRADO_SISTEMA,
    CAMPO_CONTRIBUINTE_OBRIGATORIO,
    NENHUM_DEBITO_OCULTO_ENCONTRADO_SISTEMA,
    CAMPO_CONTRIBUINTE_INVALIDO,
    CAMPO_PERIODO_INVALIDO,
    DEBITOS_JA_FORAM_QUITADOS,
    DATA_PAGAMENTO_HOJE_ULTIMO_DIA_MES,
    SELECIONAR_UM_ITEM,
    PAGAMENTO_TRIBUTO_FEITO_APOS_DATA_VENCIMENTO,
    SELECIONE_CREDENCIADO,
    NENHUM_FILTRO_PREENCHIDO,
    DEBITO_OCULTADO_SELECIONADO
  };
  